import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";

const onSigninCallback = (_user) => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
const oidcConfig = {
  authority: "https://" + window.location.host + "/kc/realms/NILO",
  client_id: "nilo-fe",
  redirect_uri: "https://" + window.location.host + "/",
  onSigninCallback: onSigninCallback,
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider {...oidcConfig}>
          <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
